import { Button, Form } from 'antd';
import styled from 'styled-components';

export const WrapContainer = styled.div`
  background-color: white;
  margin: 10px 50px;
  padding: 25px 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  & h3 {
    margin: 0;
  }
  & .ant-form-item {
    width: 100%;
  }
`;

export const SubWrapContainer = styled.div`
  max-width: 340px;
  width: calc(100% - 40px);
  margin: 0 auto;
  padding: 25px 20px;
`;

export const FormDescription = styled.div`
  display: flex;
  margin-bottom: 24px;
  width: 100%;
`;

export const Description = styled.div`
  display: flex;
  align-items: center;
  margin-left: 15px;
`;

export const SubHeadContainer = styled.div`
  margin-bottom: 40px;
  display: flex;
`;

export const SubHeader = styled.div`
  font-weight: bold;
`;

export const AboutContent = styled.div`
  font-weight: bold;
  text-align: end;
  font-size: 14px;
  margin-top: 24px;
  &.gmail_info {
    font-weight: normal;
    font-size: 16px;
    width: 100%;
    margin-top: 0px;
    margin-bottom: 24px;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  text-align: end;
  margin-bottom: 0;
`;

export const StyledButton = styled(Button)`
  margin-top: 24px;
  width: 120px;
`;
